import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AccordionCategoryComponent } from '../container/accordion-category.component';

@Component({
  selector: 'ds-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit, AfterContentInit, OnDestroy, OnChanges {
  @ContentChildren(AccordionCategoryComponent) categories: QueryList<AccordionCategoryComponent>;
  @Input() allowToggleAccordion = false;
  @Input() allowMultipleOpenCategories = false;
  @Output() expandAllEvent = new EventEmitter();

  showExpandButton = true;
  showCollapseButton = false;
  private stop$ = new Subject<void>();

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    window.setTimeout(() => {
      this.categories.toArray().forEach(categoryInstance => {
        this.addCategory(categoryInstance);
      });
      this.setToggleButton();
    }, 0);
  }

  ngAfterContentInit() {
    window.setTimeout(() => {
      this.categories.toArray().forEach(categoryInstance => {
        this.addCategory(categoryInstance);
      });
      this.setToggleButton();
    }, 0);
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }

  public addCategory(category: AccordionCategoryComponent) {
    category.opening.pipe(takeUntil(this.stop$)).subscribe(openingCategory => {
      this.opening(openingCategory);
    });
    category.closing.pipe(takeUntil(this.stop$)).subscribe(() => {
      this.closing();
    });
    this.setToggleButton();
  }

  expandAll() {
    if (this.categories && this.categories.length) {
      this.categories.forEach(category => {
        category.open();
      });
      this.expandAllEvent.emit();
    }
    this.setToggleButton();
  }

  collapseAll() {
    if (this.categories && this.categories.length) {
      this.categories.forEach(category => {
        category.close();
      });
    }
    this.setToggleButton();
  }

  private opening(openingCategory: AccordionCategoryComponent) {
    if (!this.allowMultipleOpenCategories) {
      this.categories.forEach(category => {
        if (category.isOpen && category !== openingCategory) {
          category.close();
        }
      });
    }
    this.setToggleButton();
  }

  private closing() {
    this.setToggleButton();
  }

  private setToggleButton() {
    if (this.categories) {
      // IF any category is closed, enable the expand button
      this.showExpandButton = this.categories.find(c => c && !c.isOpen) != null;
      // IF any category is open, enable the collapse button
      this.showCollapseButton = this.categories.find(c => c && c.isOpen) != null;
    }
    // IF there are no categories, disable expand & collapse
    else {
      this.showExpandButton = false;
      this.showCollapseButton = false;
    }
  }
}
